import { useCallback, useContext } from 'react';
import { SiteSettingsContext } from '@namespace/cms/src/store/siteSettings/context';
import { MODAL_QUERY_PARAMETER_NAME } from '../../constants';
import { removeLangFromPathname } from '../../utils/removeLangFromPathname';

/**
 * This function determines if a specific route should be
 * opened as a modal. It appends a query parameter
 * `route-in-modal={route}` to the URL.
 */
export const useModifyIfRouteShouldBeInModal = () => {
  const [siteSettings] = useContext(SiteSettingsContext);

  const { routesAsModalOnly } = siteSettings || {};

  return useCallback(
    (path) => {
      const pathWithoutLanguage = removeLangFromPathname(path);
      if (
        routesAsModalOnly &&
        routesAsModalOnly.some((route) => pathWithoutLanguage.startsWith(route))
      ) {
        const [route, searchParams] = pathWithoutLanguage.split('?');
        const searchState = new URLSearchParams(searchParams);

        searchState.append(MODAL_QUERY_PARAMETER_NAME, route);

        return `?${searchState.toString()}`;
      }

      return path;
    },
    [routesAsModalOnly]
  );
};
